import type { EventsFeed } from './eventsFeed'

export type PublicEvent = {
  id: number
  external_id: string | null
  name: string
  intro: string | null
  url: string | null
  tags: string[]
  starts_at: string | null
  ends_at: string | null
  time_zone: string
  online: boolean
  event_type: { id: number; name: string }
  group: { id: number; name: string; slug: string } | null
  venue: {
    name: string | null
    one_line: string | null
    address: { line1: string | null; city: string | null; state: string | null; postcode: string | null } | null
    lat: number | null
    lng: number | null
  }
  more_dates_count: number
  series_id: number
  series_name: string | null
  rsvps_count: number
  spots: {
    total: number
    filled: number
    self_sign_up: { total: number; filled: number }
  }
}

export type EventsFeedPage = {
  data: PublicEvent[]
  meta: { total: number; page: number; per_page: number; next_page: number | null }
}

const BLOCKS = 'p, div, li, br, h1, h2, h3, h4, h5, h6'

export function introText(html: string | null) {
  if (!html) return null
  const inertBody = new DOMParser().parseFromString(html, 'text/html').body
  inertBody.querySelectorAll('script, style, template').forEach((code) => code.remove())
  inertBody.querySelectorAll(BLOCKS).forEach((block) => block.after(' '))
  return inertBody.textContent?.replace(/\s+/g, ' ').trim() || null
}

export function venueText(venue: PublicEvent['venue']) {
  return [venue.name, venue.one_line].filter(Boolean).join(', ')
}

export function allOnline(events: PublicEvent[]) {
  return events.length > 0 && events.every((event) => event.online)
}

export function offersLocationSearch({
  googleMapsApiKey,
  feed,
}: {
  googleMapsApiKey: string | null
  feed: Pick<EventsFeed, 'events' | 'status'>
}) {
  return Boolean(googleMapsApiKey) && !(feed.status === 'ready' && allOnline(feed.events))
}
